<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" :account="account" @change="emitToParent">
    <div class="l-row">
      <form-group v-if="Object.keys(variation.attributes).indexOf('color') !== -1" :label="$t(`color.label`)" :columns="3" :error="getError('attributes.color', variation.sku)" :required="true">
        <input class="form-input" type="text" v-model="variation.attributes['color']" :disabled="disabledInputs()">
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('flavor') !== -1" :label="$t(`flavor.label`)" :columns="3" :error="getError('attributes.flavor', variation.sku)" :required="true">
        <input v-model="variation.attributes['flavor']" class="form-select" :disabled="disabledInputs()"></input>
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('voltage') !== -1" :label="$t(`voltage.label`)" :columns="3" :error="getError('attributes.voltage', variation.sku)" :required="true">
        <select class="form-select" v-model="variation.attributes['voltage']" :disabled="disabledInputs()">
          <option value="110V">110V</option>
          <option value="127V">127V</option>
          <option value="220V">220V</option>
          <option value="380V">380V</option>
          <option value="bivolt">bivolt</option>
        </select>
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('size') !== -1" :label="$t(`size.label`)" :columns="3" :error="getError('attributes.size', variation.sku)" :required="true">
        <input class="form-input" type="text" v-model="variation.attributes['size']" :disabled="disabledInputs()">
      </form-group>
    </div>
  </shared-provide-variation>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      sizes: [],
      colors: [],
      size: null,
      color: null
    }),
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      },
      account: {
        type: Object,
        required: false,
        default: null
      }
    },
    async mounted () {
      if (this.variation.attributes.hasOwnProperty('size') && this.variation.attributes.size) {
        this.size = this.variation.attributes.size
      }

      if (this.variation.attributes.hasOwnProperty('color') && this.variation.attributes.color) {
        this.color = this.variation.attributes.color
      }
      this.colors = []
      this.sizes = []
    },
    methods: {
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error'
      },
      emitToParent (value) {
        this.$emit('change', value)
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    watch: {
      color (value) {
        if (value === undefined) {
          this.variation.attributes.color = null
          return
        }

        if (value.label === 'Sem variação' || value === 'Sem variação') {
          if (this.variation.attributes.hasOwnProperty('color')) {
            delete this.variation.attributes.color
          }
        } else {
          this.variation.attributes.color = value
        }
      },
      size (value) {
        if (value === undefined) {
          this.variation.attributes.size = null
          return
        }

        this.variation.attributes.size = value
      }
    },
    components: {
      SharedProvideVariation,
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// Variation.vue?dde62c26